/**
 * Listing Components
 *
 * Reusable components for product listing pages (PLP).
 * These components power the watch listings, strap listings, and other
 * product collection pages.
 *
 * Usage:
 *   import { ListingFilters, ProductListingPage } from '@/components/listing';
 */

// Unified Page Component (use this for all PLPs)
export { ActiveFilters } from './ActiveFilters';
export { CollectionFilter } from './CollectionFilter';
export { FacetFilter } from './FacetFilter';
// Filter components
export { FilterBar } from './FilterBar';
// Main orchestration components
export { ListingFilters } from './ListingFilters';
export { MaterialTabs } from './MaterialTabs';
export type { FilterBarPosition } from './ListingFilters';
// Hero
export { PLPHero, PLPHeroSimple } from './PlpHero';
export { PriceRangeFilter } from './PriceRangeFilter';
export { PriceSliderFilter } from './PriceSliderFilter';
export { ProductListingPage, type ProductListingPageProps } from './ProductListingPage';
export { RefNumberFilter } from './RefNumberFilter';
export { SortFilter } from './SortFilter';
export { SortSelect } from './SortSelect';
export { SwatchFilter } from './SwatchFilter';
